var _path, _circle, _g, _path2, _path3, _circle2, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasNoLeak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m96 312h48v64h-48z",
    fill: "#efdd9b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 240,
    r: 88,
    fill: "#8bcde8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#efbf33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112 166.67h16v33.333h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.316 193.64 11.312-11.312 23.712 23.712-11.312 11.312z",
    strokeWidth: 0.99985
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.59 206.04 26.879-26.879 11.312 11.312-26.879 26.879z",
    strokeWidth: 0.99985
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m120 152a88 88 0 1 0 88 88 88.001 88.001 0 0 0-88-88zm0 152a64 64 0 1 1 64-64 63.995 63.995 0 0 1-64 64z",
    fill: "#2f4054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m74.423 257.07 41.568-24 7.9995 13.855-41.568 24z",
    fill: "#e54042",
    strokeWidth: 0.99998
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 240,
    r: 16,
    fill: "#2f4054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m56 376h400v96h-400z",
    fill: "#efdd9b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m24 360h32v128h-32z",
    fill: "#e54042"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m456 360h32v128h-32z",
    fill: "#e54042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m96 360h48v16h-48z",
    fill: "#efbf33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasNoLeak);
export default __webpack_public_path__ + "static/media/gas_no_leak.5e510e2c17e72a1966ceba7ed87b4b01.svg";
export { ForwardRef as ReactComponent };